module.exports = __webpack_public_path__ + "static/media/liveroom-setting-coupon.998a3992.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-coupon.png
// module id = 2038
// module chunks = 6